const features = [
  {
    icon: "⏱️",
    title: "Save Time & Effort",
    desc: "Quick ID Cards minimizes manual work and completes the entire ID card process quickly and efficiently."
  },
  {
    icon: "📸",
    title: "Photo Capture App",
    desc: "Exclusive photo capture app that allows teachers to easily take and upload student photos."
  },
  {
    icon: "⚙️",
    title: "Eliminate Manual Errors",
    desc: "Teachers handle corrections directly in the app, avoiding manual data exchange and confusion."
  },
  {
    icon: "🎖️",
    title: "Quality Assurance",
    desc: "Premium lanyards, acrylic holders, and durable PVC/RFID cards."
  },
  {
    icon: "🎨",
    title: "Custom Branding",
    desc: "Custom colors, logos, and ID templates tailored to your school identity."
  },
  {
    icon: "✅",
    title: "End-to-End Service",
    desc: "Complete solution from data capture to printing and doorstep delivery."
  }
];

export default function ChooseSection() {
  return (
    <section className="choose-section">
      <div className="choose-container">

        <h2>
          Why Choose <span>Quick ID Cards?</span>
        </h2>

        <p className="choose-subtitle">
          We provide a complete, reliable, and professional ID card solution for schools and institutions.
        </p>

        <div className="choose-grid">
          {features.map((item, i) => (
            <div key={i} className="choose-box">

              <h3>
                <span className="icon">{item.icon}</span> {item.title}
              </h3>

              <p>{item.desc}</p>

            </div>
          ))}
        </div>

        <div className="brochure-btn">
          <a
            href="/img2/QuickIDCards-Brochures.pdf"
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            📄 Download Brochure
          </a>
        </div>

      </div>
    </section>
  );
}
